<div class="entity-table-block overflow-y-hidden">
    <div class="entity-table-header flex pt-12 px-6 flex-row justify-between">
        <div class="flex items-center flex-none">
            <span class="font-normal text-2xl flex flex-row justify-center items-center">
                <fa-icon
                    class="mr-2 text-secondary"
                    [icon]="['far', 'rectangle-list']" />
                @if (onlySelected()) {
                    {{ 'selectedEntities' | transloco }}
                } @else if (!isTableCreatedEntities()) {
                    {{ 'projectEntities' | transloco }}
                } @else {
                    {{ 'projectCreatedEntities' | transloco }}
                }
            </span>
        </div>
        <div class="flex items-center justify-end gap-6 flex-row">
            <app-entity-table-selection />
            <mat-divider
                class="h-8 bg-secondary-container"
                [vertical]="true" />
            <app-entity-table-edit-toolbar
                [canDelete]="canDeleteEntities()"
                [canRedoEdit]="editModeStateService.canReapply()"
                [canUndoEdit]="editModeStateService.canCancel()"
                [canUseGlobalEditButton]="canUseGlobalEditButton()"
                [canUseTableEditToggle]="canDisplayTableEditToggle()"
                [canValidate]="canValidateEdits()"
                [currentTableEditMode]="currentTableEditMode()"
                [deleteTooltip]="deleteTooltip()"
                [isEditModeActive]="isTableEditSessionActive()"
                [isEditable]="isActiveLayerEditable()"
                [isEditionInProgress]="entityEditPanelGuardService.hasPendingEntityEdition()"
                (deleteEntities)="deleteEntities()"
                (redoEdit)="redoEdit()"
                (switchToggledMode)="switchToggledMode($event)"
                (toggleEditMode)="toggleEditMode()"
                (undoEdit)="undoEdit()"
                (validateEntities)="validateEdit()" />
        </div>
    </div>
    @if (!isLoading()) {
        @if (isTableCreatedEntities()) {
            <app-entity-created-table
                [onlySelected]="onlySelected()"
                (switchCreatedEntitiesTable)="switchCreatedEntitiesTable()"
                (toggleOnlySelectedEntities)="toggleOnlySelectedEntities()" />
        } @else if (projectEntityTableService.layerNames().length) {
            <div class="entity-table-content h-full">
                <div class="app-tab-container">
                    @if (homeService.isExternalPage()) {
                        <div class="h-full w-full flex">
                            <div class="flex-1 flex min-h-0 grow">
                                <div class="overflow-x-auto w-full">
                                    <ng-container *ngTemplateOutlet="customTableTemplate" />
                                </div>
                            </div>
                        </div>
                    } @else {
                        @if (!tabs().length) {
                            <div class="bg-white h-full flex items-center justify-center">
                                <app-no-data-to-display
                                    displayedMessage="noDataToShow"
                                    [iconSize]="'5x'" />
                            </div>
                        } @else {
                            <app-tab
                                [defaultTabIndex]="projectEntityTableService.forceTabIndex()"
                                [tabs]="tabs()"
                                [tabsBadge]="layersEditBadges()"
                                [translateTabs]="false"
                                (changeTab)="changeTab($event)"
                                (create)="onCreateEntity($event)">
                                @for (tab of tabs(); track tab.name) {
                                    <ng-template appTabContent>
                                        @if (projectEntityTableService.areLayersDefined()) {
                                            <div class="overflow-x-auto">
                                                <ng-container *ngTemplateOutlet="customTableTemplate" />
                                            </div>
                                        } @else {
                                            <div class="bg-white h-full flex items-center justify-center">
                                                <app-no-data-to-display
                                                    displayedMessage="noDataToShow"
                                                    [iconSize]="'5x'" />
                                            </div>
                                        }
                                    </ng-template>
                                }
                            </app-tab>
                        }
                    }
                </div>
            </div>

            <div
                class="entities-list-footer-container"
                [class.bg-white]="!homeService.isExternalPage()">
                <app-pagination-footer-template
                    [canSearch]="true"
                    [forceAlignment]="Alignment.ROW"
                    [paginationParameters]="projectEntityTableService.paginationParameters()"
                    [searchDisabled]="!layerTotalItems()"
                    [selectedEntitiesNumber]="selectedEntityCount()"
                    [selectedLayerNumber]="selectedLayerCount()"
                    [totalEntities]="projectEntityTableService.paginationParameters().totalItems"
                    [(forceReset)]="projectEntityTableService.forceResetSearchBar"
                    (handleSearch)="projectEntityTableService.handleSearch($event)"
                    (onPageChange)="projectEntityTableService.onPageChange($event)"
                    (paginator)="projectEntityTableService.onPaginatorChange($event)">
                    @if (isEditSessionActive()) {
                        <app-button
                            [disabled]="isSwitchDisabled()"
                            [icon]="['fas', 'eye']"
                            [label]="'displayEntities' | transloco: { TYPE: 'create' }"
                            [tooltip]="switchTooltip() | transloco"
                            [type]="ButtonType.SECONDARY"
                            (onClick)="switchCreatedEntitiesTable()" />
                    }

                    @if (selectionService.isSelectionActive()) {
                        <app-button
                            [icon]="['fas', 'eye']"
                            [label]="(onlySelected() ? 'displayAllEntities' : 'displayOnlySelection') | transloco"
                            (onClick)="toggleOnlySelectedEntities()" />
                    }
                </app-pagination-footer-template>
            </div>
        } @else {
            <app-no-data-to-display
                class="h-full"
                [iconSize]="'5x'" />
        }
    } @else {
        <div class="min-h-45 min-w-full flex items-center justify-center h-full">
            <app-loading />
        </div>
    }
</div>

<ng-template #customTableTemplate>
    <div
        class="entity-table-custom-table-wrapper"
        [class.entity-table-custom-table-wrapper--edit-mode]="isInlineTableEditActive()"
        [class.entity-table-custom-table-wrapper--external]="homeService.isExternalPage()">
        <app-custom-table
            [columns]="tableColumns()"
            [headerCheckboxState]="headerCheckboxState()"
            [isSelectable]="isSelectableCheckbox()"
            [translateColumns]="true"
            (sortEvent)="projectEntityTableService.onSortChange($event)"
            (toggleAllSelectedEvent)="toggleAllSelected()">
            @if (projectEntityTableService.isLoading()) {
                <tr>
                    <td
                        class="text-center py-4"
                        [attr.colspan]="tableColumns().length">
                        <div class="loader w-full h-30 m-auto py-10">
                            <app-loading />
                        </div>
                    </td>
                </tr>
            } @else {
                @for (dataEntity of projectEntityTableService.entities(); track $index) {
                    <tr
                        [attr.data-deleted-label]="
                            isEntityPendingDeleteInEditMode(dataEntity.uuid) ? ('editMode.deleted' | transloco) : null
                        "
                        [class.!bg-white]="
                            homeService.isExternalPage() || currentTableEditMode() === TableEditMode.TABLE_EDIT
                        "
                        [class.details-opened]="isRowDetailsOpened(dataEntity.uuid)"
                        [class.entity-row--pending-delete]="isEntityPendingDeleteInEditMode(dataEntity.uuid)"
                        [class.entity-row--pending-delete-detail]="isEntityPendingDeleteInDetailMode(dataEntity.uuid)"
                        [style.cursor]="getRowCursor(dataEntity.uuid)"
                        (click)="onRowClick(dataEntity)">
                        @if (isSelectableCheckbox()) {
                            <td>
                                <app-checkbox
                                    [checkboxState]="getSelectedRowCheckboxState(dataEntity.uuid)"
                                    (click)="toggleEntitySelection(dataEntity, $event)" />
                            </td>
                        }

                        @for (column of tableColumns(); track column.key) {
                            <td
                                app-entity-table-cell
                                [attributeInfo]="getAttributeInformation(column.key)"
                                [businessIdentifierKey]="attributeInformationContext.businessIdentifierKey()"
                                [column]="column"
                                [columnNamesWithReference]="columnNamesWithReference()"
                                [dataEntity]="dataEntity"
                                [isCellEditActive]="isCellEditable(dataEntity.uuid)"
                                [isEditSessionActive]="isEditSessionActive()"
                                [isInlineTableEditActive]="isInlineTableEditActive()"
                                [isNumeric]="hasNumericType(column.key)"
                                [isPendingDelete]="isEntityPendingDeleteInTableMode(dataEntity.uuid)"
                                [layerId]="activeLayerId()!"
                                [projectId]="getProjectId()!"></td>
                        }
                        <td class="entity-row-delete-cell">
                            @if (isEntityPendingDeleteInEditMode(dataEntity.uuid)) {
                                <div class="entity-row-delete-badge">
                                    <app-label-badge
                                        [baseIcon]="['fas', 'trash']"
                                        [iconPosition]="LabelIconPosition.END"
                                        [tooltip]="'editMode.deletedEntity' | transloco"
                                        [variant]="LabelBadgeVariant.DANGER" />
                                </div>
                            }
                        </td>
                    </tr>
                } @empty {
                    <tr>
                        <td
                            class="text-center"
                            [attr.colspan]="tableColumns().length + (isSelectableCheckbox() ? 1 : 0) + 1"
                            [class.bg-white]="!homeService.isExternalPage()">
                            <div class="flex h-full w-full items-center justify-center">
                                <app-no-data-to-display
                                    displayedMessage="noDataToShow"
                                    [iconSize]="'5x'" />
                            </div>
                        </td>
                    </tr>
                }
            }
        </app-custom-table>
    </div>
</ng-template>
